<div>
    <app-dash-nav></app-dash-nav>
</div>
<div class="body">
    <div class="head">
        <h1>Mentor Profile</h1>
    </div>
    <div class="cont">
        <div class="profile">
            <h1>Add a Slot</h1>
            <div class="firstrow">
                <div class="image">
                    <form [formGroup]="firstFormGroup">
                    <mat-label>Date</mat-label>
                    <mat-form-field appearance="outline" class="input-field">
                        <input matInput type="date" placeholder="Date" formControlName="date" required>
                        <mat-error *ngIf="firstFormGroup.controls['date'].hasError('required')">
                            Date is required!
                        </mat-error>
                      </mat-form-field><br>
                      <mat-label>Time</mat-label>
                    <mat-form-field appearance="outline" class="input-field">
                        <input matInput type="time" placeholder="Time" formControlName="time" required>
                        <mat-error *ngIf="firstFormGroup.controls['time'].hasError('required')">
                            Time is required!
                        </mat-error>
                      </mat-form-field><br>
                      <div class="submit">
                        <button class="btn btn-lg inverse" (click)="addslot()">Submit</button>
                      </div>
                    </form>
                    <!-- <img src={{mentordata.profile_img}} alt=""> -->
                </div>
                <div class="basic">
                    <!-- <h1>{{mentordata.mentor_id}}</h1> -->
                    <!-- <h1>{{mentordata.name}}</h1> -->
                    <!-- <h1>Designation</h1> -->
                </div>
            </div>
            <div class="secondrow">
                <!-- <p>{{mentordata.expertise}}</p> -->
            </div>
        </div>
    <div class="slots">
        <h2>Added Slot</h2>
        <div class="slot"  *ngFor="let slot of addedslots">
            <button class="btn btn-lg inverse" disabled>{{formatDateAndTime(slot.date, slot.time)}}</button>
        </div>
        <!-- <div class="book">
            <button class="btn btn-lg inverse2">Book Slot</button>
        </div> -->
    </div>
    </div>
    <!-- <div class="head">
        <button class="btn btn-lg">Confirmed Slots</button>
        <div class="slots">
            <div class="slot">

            </div>
        </div>
    </div> -->
</div>